module.exports = __webpack_public_path__ + "static/media/almqr.05714cac.webp";